import General from "../utils/General";

export const _sponsoreChannelLogo = (webinarItem) => {
    var logoStr = "";
    if (webinarItem.channel) {
      logoStr = webinarItem.channel.logo;
    } else if (webinarItem.sponsorship) {
      logoStr = webinarItem.sponsorship.logo;
    }
    return logoStr;
}

export const _sponsoreChannelCategory = (webinarItem) => {
    var categoryStr = "Dipersembahkan oleh";
    if (webinarItem.channel) {
      categoryStr = webinarItem.channel.channel_sponsorship_name;
    }
    return categoryStr;
}

export const _sponsoreChannelName = (webinarItem) => {
    var nameStr = "";
    if (webinarItem.channel) {
      nameStr = webinarItem.channel.name;
    } else if (webinarItem.sponsorship) {
      nameStr = webinarItem.sponsorship.name;
    }
    return nameStr;
}

 export const _isShowSponsoreChannel = (webinarItem) => {
    return webinarItem.sponsorship || webinarItem.channel;
}

export const _isShowGreenCard = (webinar, isRegister) => {
  let isEvent = webinar.total_session.length > 1
  let showGreen = false
    if (isRegister && webinar.broadcast_status != "finished") {
      if (isEvent) {
        showGreen = true
      } else if (!isEvent && webinar.broadcast_status === 'publish') {
        showGreen = true
      }
    }
    return showGreen
}

export const _isShowRegisterButton = (webinar, isRegister) => {
    return (
      isRegister === false &&
      webinar.broadcast_status !== "live" &&
      webinar.broadcast_status !== "finished" &&
      webinar.is_paid_webinar == false
    );
}

export const _isShowPaidWebinarButton = (isRegister, webinar) => {
    return isRegister === false && webinar.is_paid_webinar === true;
}

export const _isStrikethroughPrice = (webinar) => {
  if (webinar && webinar.payment_info) {
    let base_price = General.getNumber(webinar.payment_info.base_price);
    let special_price = General.getNumber(webinar.payment_info.normal_price);
    return base_price > special_price;
  }
  return false;
};

export const goToCheckOutPage = () => {
    const webinarId = window.location.pathname.split("/").pop();
    window.location = `/payment/list/webinar?id=${webinarId}`
}

export const labelBanner = (broadcast_status) => {
  if(broadcast_status == "live") {
    return "bg-live"
  }else if(broadcast_status == "finished") {
    return "bg-finished"
  }
}

export const _formattedAddSpace = (value) => {
  return value && value.replaceAll(',', ', ');
}

export const _checkShowVideo = (isLogin, webinar) => {
  if(isLogin == 1) {
    if(webinar.is_paid_webinar){
      if(webinar.is_registered && webinar.broadcast_status == "live" && !isEmpty(webinar.broadcast_url)) {
        return true
      } else if (webinar.is_registered && webinar.broadcast_status == "finished" && !isEmpty(webinar.video_recording_url)) {
        return true
      } else {
        return false
      }
    } else {
      if(webinar.broadcast_status == "live" && !isEmpty(webinar.broadcast_url)){
        return true
      }else if(webinar.broadcast_status == "finished" && !isEmpty(webinar.video_recording_url)){
        return true
      }else{
        return false
      }
    }
  } else {
    return false
  }
}

function isEmpty(val){
  return (val === undefined || val == null || val.length <= 0) ? true : false;
}

export const _checkStartPosttestSingle = (isLogin, webinar) => {
  if(isLogin == 1) {
    if(webinar.is_paid_webinar){
      return webinar.is_registered && webinar.broadcast_status == "finished" && webinar.is_post_test_available && !webinar.is_part_of_event && (webinar.post_test_status == "not_done" || webinar.post_test_status == "failed");
    }else{
      return webinar.broadcast_status == "finished" && webinar.is_post_test_available && !webinar.is_part_of_event && (webinar.post_test_status == "not_done" || webinar.post_test_status == "failed")
    }
  } else {
    return false
  }
}

export const _checkStartPosttestEvent = (isLogin, webinar) => {
  if(isLogin == 1) {
    if(webinar.is_paid_webinar){
      return webinar.is_registered && webinar.broadcast_status == "finished" && webinar.is_post_test_available && (webinar.post_test_status == "not_done" || webinar.post_test_status == "failed");
    }else{
      return webinar.broadcast_status == "finished" && webinar.is_post_test_available && (webinar.post_test_status == "not_done" || webinar.post_test_status == "failed");
    }
  } else {
    return false
  }
}

export const _checkCertificateSingle = (isLogin, webinar) => {
  if(isLogin == 1) {
    if(webinar.is_paid_webinar){
      return webinar.is_registered && webinar.broadcast_status == "finished" && webinar.is_post_test_available && !webinar.is_part_of_event && webinar.post_test_status == "pass";
    }else{
      return webinar.broadcast_status == "finished" && webinar.is_post_test_available && !webinar.is_part_of_event && webinar.post_test_status == "pass";
    }
  } else {
    return false
  }
}

export const _checkCertificateEvent = (isLogin, webinar) => {
  if(isLogin == 1) {
    if(webinar.is_paid_webinar){
      return webinar.is_registered && webinar.broadcast_status == "finished" && webinar.is_post_test_available && webinar.post_test_status == "pass";
    }else{
      return webinar.broadcast_status == "finished" && webinar.is_post_test_available && webinar.post_test_status == "pass";
    }
  } else {
    return false
  }
}

export const _webinarEventStatus = (webinarEvent) => {
  let PUBLISH = "publish";
  let LIVE = "live";
  if (webinarEvent) {
    if (webinarEvent.broadcast_status === PUBLISH) {
      return "upcoming";
    } else if (webinarEvent.broadcast_status === LIVE) {
      return "live";
    } else {
      return "end";
    }
  }
};

export const _checkIconPlayShow = (status, isLogin) => {
  return (status == "live" || status == "finished") && !isLogin;
}